import { createApp } from "vue";
import App from "./App.vue";
import store from "./store/index";
// ROUTER
import router from "./router";
// FIREBASE (single app initialization)
import { initializeAuthObserver, waitForAuthReady } from "@/services/authService";
import {
  clearDebugLogs,
  downloadDebugLogs,
  logDebugEvent
} from "@/services/debugLogs";
import {
  getAnalyticsDebugStatus,
  initAnalyticsIfConsented,
  registerAnalyticsApp,
  sendAnalyticsDebugTestEvent,
  startAnalyticsConsentWatcher
} from "@/services/analyticsService";
export { legacyDb as db } from "./firebase";
// QUILL
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
// BOOSTRAP
import { BootstrapVue } from "bootstrap-vue";
import { BootstrapIconsPlugin } from "bootstrap-icons-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/main.sass";
// YOUTUBE
import VueYouTubeEmbed from "vue3-youtube";

async function bootstrap() {
  initializeAuthObserver();
  await waitForAuthReady();

  const app = createApp(App);
  app.config.errorHandler = (error, instance, info) => {
    logDebugEvent("app", "vue-error", {
      message: error?.message || String(error || ""),
      info: info || null,
      component:
        instance?.type?.name ||
        instance?.type?.__name ||
        instance?.$options?.name ||
        null
    });
    console.error(error);
  };
  app.use(store);
  app.use(router);
  app.use(BootstrapVue);
  app.use(BootstrapIconsPlugin);
  app.use(VueYouTubeEmbed);
  app.component("QuillEditor", QuillEditor);

  registerAnalyticsApp(app);
  startAnalyticsConsentWatcher();
  initAnalyticsIfConsented();

  app.mount("#app");

  window.engramDebug = {
    analyticsStatus: getAnalyticsDebugStatus,
    sendAnalyticsTestEvent: sendAnalyticsDebugTestEvent,
    downloadLogs: downloadDebugLogs,
    clearLogs: clearDebugLogs
  };

  logDebugEvent("app", "bootstrap-complete", {
    route: window.location.pathname
  });
}

bootstrap();
